<app-form-select-new [formControl]="formControl"
                     [data]="itemsList$ | push"
                     [required]="required"
                     [readonly]="readonly"
                     [label]="'Surface Type'"
                     (itemSelected)="itemSelected($event)"></app-form-select-new>
